import React, { lazy, Suspense } from 'react';

const LazyTechSupportPage = lazy(() => import('./TechSupportPage'));

const TechSupportPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyTechSupportPage {...props} />
  </Suspense>
);

export default TechSupportPage;
